import { z } from 'zod';

export const NameSchema = z.string().min(2, 'Minst 2 tecken').max(255, 'Max 255 tecken');
